import React, { useEffect, useState } from 'react';

/**
 * Aviso fijo arriba cuando se pierde la conexion, con acceso directo a OmniERP Lite
 * (REACT_APP_LITE_URL). Sin esa variable no se muestra nada.
 */
const BannerSinConexion = () => {
  const urlLite = process.env.REACT_APP_LITE_URL;
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const encender = () => setOnline(true);
    const apagar = () => setOnline(false);
    window.addEventListener('online', encender);
    window.addEventListener('offline', apagar);
    return () => {
      window.removeEventListener('online', encender);
      window.removeEventListener('offline', apagar);
    };
  }, []);

  if (!urlLite || online) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10000,
        background: '#b45309', color: '#fff', padding: '8px 16px',
        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, flexWrap: 'wrap',
        fontSize: 14, boxShadow: '0 2px 6px rgba(0,0,0,.3)',
      }}
    >
      <span>Sin conexión a internet. Puedes seguir facturando sin conexión con OmniERP Lite.</span>
      <a
        href={urlLite}
        style={{ background: '#fff', color: '#b45309', padding: '4px 12px', borderRadius: 6, fontWeight: 600, textDecoration: 'none' }}
      >
        Abrir OmniERP Lite
      </a>
    </div>
  );
};

export default BannerSinConexion;
